module.exports = __webpack_public_path__ + "h5/img/hb2-1.d6fd34e1.png";